import { App } from 'antd'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import companyGroupQueryKeys from './companyGroupQueryKeys'
import { updateSubsidiaryOrders, SubsidiaryOrder } from '../service/subsidiaryService'
import { Company } from '../../../types/company/Company'
import { CompanyGroup } from './getCompanyGroupOptions'

interface UpdateOrdersVariables {
  orders: SubsidiaryOrder[]
  newList: Company[]
}

export const useUpdateSubsidiaryOrders = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()
  const { message } = App.useApp()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: ({ orders }: UpdateOrdersVariables) => {
      if (!companyId) throw new Error('Company ID is required')
      return updateSubsidiaryOrders(companyId, orders)
    },
    onSuccess: (_data, { newList }) => {
      queryClient.setQueryData<CompanyGroup>(companyGroupQueryKeys.group({ companyId }), old =>
        old ? { ...old, subsidiaries: newList } : old
      )
      message.success(t('messages:updateSuccess'))
    },
    onError: () => {
      message.error(t('messages:updateError'))
    }
  })
}
